var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <td data-js-perf-switch-week=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"performanceWeek") : depth0), depth0))
    + "\" class=\"table-date-head\n            "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(data && lookupProperty(data,"index")),0,{"name":"compare","hash":{"operator":"=="},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":12},"end":{"line":6,"column":87}}})) != null ? stack1 : "")
    + "\n      "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"performanceCount") : depth0),0,{"name":"compare","hash":{"operator":"=="},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":6},"end":{"line":7,"column":90}}})) != null ? stack1 : "")
    + "\n            \"\n    >\n      "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"headline") : depth0), depth0))
    + "\n    </td>\n\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "table-date-head--highlighted";
},"4":function(container,depth0,helpers,partials,data) {
    return "table-date-head--empty";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<thead>\n<tr class=\"timetable-head-tr\">\n\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"completeTableHeadline") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":2},"end":{"line":13,"column":11}}})) != null ? stack1 : "")
    + "</tr>\n\n</thead>\n";
},"useData":true});